import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { ReactElement, ReactNode } from 'react';

export type PageHeadingProps = {
    title: string;
    description?: ReactNode;
    actions?: ReactNode;
};

export function PageHeading({ title, description, actions }: PageHeadingProps): ReactElement {
    return (
        <Box
            component="header"
            sx={{
                display: 'flex',
                alignItems: description === undefined ? 'center' : 'flex-start',
                justifyContent: 'space-between',
                gap: 2,
                py: 2,
            }}>
            <Box>
                <Typography variant="h5" component="h1">
                    {title}
                </Typography>
                {description !== undefined && (
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                        {description}
                    </Typography>
                )}
            </Box>
            {actions !== undefined && <Box>{actions}</Box>}
        </Box>
    );
}
